import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    access: localStorage.getItem("access"),
    refresh: localStorage.getItem("refresh"),
    isAuthenticated: null,
    user: null,
}

const authenticationSlice = createSlice({
    name:'authentication',
    initialState,
    reducers:{
        setLoginSucess:(state,{payload})=>{
            localStorage.setItem('access',payload.access)
            localStorage.setItem('refresh',payload.refresh)
            state.access = payload.access
            state.refresh = payload.refresh
            state.isAuthenticated = true
        },
        setLoginFail:(state,{payload})=>{
            localStorage.removeItem('access')
            localStorage.removeItem('refresh')
                
            state.access = null
            state.refresh = null
        },
        setUserLoadSuccess:(state,{payload})=>{
            state.user = payload
            localStorage.setItem("currentUserId",payload.id)
        },
        setUserLoadFail:(state,{payload})=>{
           state.user = null
        },
        setAuthenticatedSuccess:(state,{payload}) =>{
            //  console.log(localStorage);
            state.isAuthenticated = true
        },
        setAuthenticatedFail:(state,{payload}) =>{
            //  console.log(localStorage);
            state.isAuthenticated = false
        },
        setLogout:(state,{payload}) =>{
            //  console.log(localStorage);
            localStorage.removeItem('access')
            localStorage.removeItem('refresh')
                
            state.access = null
            state.refresh = null
            state.isAuthenticated = false
            state.user = null
        },
        setPasswordResetSuccess:(state,{payload}) =>{

        },
        setPasswordResetFail:(state,{payload}) =>{

        },
        setPasswordResetConfirmSuccess:(state,{payload}) =>{

        },
        setPasswordResetConfirmFail:(state,{payload}) =>{

        },
        setRegisteringSuccess:(state,{payload}) =>{
            state.isAuthenticated = false
            
        },
        setRegisteringFail:(state,{payload}) =>{

        },
        setActivationAccountSuccess:(state,{payload}) =>{

        },
        setActivationAccountFail:(state,{payload}) =>{

        },
    }
})

export const { 
        setLoginFail,setLoginSucess,setUserLoadFail,
        setUserLoadSuccess,setAuthenticatedFail,setAuthenticatedSuccess,
        setLogout,setPasswordResetConfirmFail,setPasswordResetConfirmSuccess,
        setPasswordResetFail,setPasswordResetSuccess,setActivationAccountFail,
        setActivationAccountSuccess,setRegisteringFail,setRegisteringSuccess
    } = authenticationSlice.actions
export default authenticationSlice.reducer